import request from '@/services/interceptor.js'

export const upload_allegato_macchina = (macchinaId, file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request({
        url: `/allegati/macchina/${macchinaId}`,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        loadingBar: true
    })
}

export const upload_allegato_manutenzione = (manutenzioneId, file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request({
        url: `/allegati/manutenzione/${manutenzioneId}`,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        loadingBar: true
    })
}

export const elimina_allegato = (id) => {
    return request({
        url: `/allegati/${id}`,
        method: 'delete',
        loadingBar: true
    })
}

// Stesso pattern di upload_allegato_macchina/upload_allegato_manutenzione,
// applicato a Mezzo e ScadenzaMezzo (Fase 5): il backend estende l'enum
// TipoEntita di FileAllegato con Mezzo/ScadenzaMezzo e aggiunge le rotte
// analoghe in AllegatiController.
export const upload_allegato_mezzo = (mezzoId, file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request({
        url: `/allegati/mezzo/${mezzoId}`,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        loadingBar: true
    })
}

export const upload_allegato_scadenzaMezzo = (scadenzaMezzoId, file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request({
        url: `/allegati/scadenzamezzo/${scadenzaMezzoId}`,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        loadingBar: true
    })
}